import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const skudApi = createApi({
  reducerPath: 'skudApi',
  baseQuery: rtkBaseQuery('/staff/Skud'),
  tagTypes: ['Skud'],
  endpoints: (builder) => ({
    inOffice: builder.mutation({
      query: ({ staffId }) => ({
        url: `/InOffice/${staffId}`,
        method: 'POST',
      }),
    }),
    isInOffice: builder.query({
      query: (params) => ({
        url: '/InOffice',
        method: 'GET',
        params,
      }),
    }),
    fetchSessionsByStaffId: builder.mutation({
      query: (body) => ({
        url: '/SessionsByStaffId',
        method: 'POST',
        body,
      }),
    }),
    getSessionsAllStaff: builder.mutation({
      query: ({ dateStart, dateStop, ...body }) => ({
        url: `SessionsAllStaff?dateStart=${dateStart}&dateStop=${dateStop}`,
        method: 'POST',
        body,
      }),
    }),
    getAttendancesByStaff: builder.query({
      query: ({ date, staffId }) => `GetAttendanceByStaff?date=${date}&staffId=${staffId}`,
    }),
    getUserDailyVisitPercent: builder.query({
      query: (params) => ({
        url: 'UserDailyVisitPercent',
        params,
      }),
    }),
    getUserDailyVisitCount: builder.query({
      query: (params) => ({
        url: 'UserDailyVisitCount',
        params,
      }),
    }),
    getUsersDailyVisitList: builder.query({
      query: (params) => ({
        url: 'UsersDailyVisitList',
        params,
      }),
    }),
    getUserDailyVisitPercentAndCount: builder.query({
      query: (params) => ({
        url: 'UserDailyVisitPercentAndCount',
        params,
      }),
    }),
    getAttendanceByDepartmentsReport: builder.query({
      query: (params) => ({
        url: 'GetAttendanceReport',
        method: 'GET',
        params,
      }),
    }),
    getMonthAttendanceReportByDepartment: builder.query({
      query: (params) => ({
        url: 'GetMonthAttendanceReportByDepartment',
        method: 'GET',
        params,
      }),
    }),
    getAttendanceByDatetime: builder.mutation({
      query: (params) => ({
        url: '/GetAttendanceByDatetime',
        method: 'POST',
        params,
      }),
    }),
    getReportAttendanceForDay: builder.query({
      query: (params) => ({
        url: 'GetReportAttendanceForDay',
        params,
      }),
    }),
    getReportAttendanceForDayMut: builder.mutation({
      query: (params) => ({
        url: 'GetReportAttendanceForDay',
        params,
      }),
    }),
    getVisitsDetailsForDays: builder.query({
      query: (params) => ({
        url: 'GetVisitsDetailsForDays',
        params,
      }),
    }),
    getDailyAttendanceDataByManager: builder.query({
      query: (params) => ({
        url: 'GetDailyAttendanceDataByManager',
        params,
      }),
    }),
    getCalculateDepartmentTotal: builder.query({
      query: (params) => ({
        url: 'CalculateDepartmentTotal',
        params,
      }),
    }),
  }),
});

export const {
  useInOfficeMutation,
  useIsInOfficeQuery,
  useFetchSessionsByStaffIdMutation,
  useGetSessionsAllStaffMutation,
  useGetAttendancesByStaffQuery,
  useGetUserDailyVisitPercentQuery,
  useGetUserDailyVisitCountQuery,
  useGetUsersDailyVisitListQuery,
  useGetUserDailyVisitPercentAndCountQuery,
  useGetAttendanceByDepartmentsReportQuery,
  useGetAttendanceByDatetimeMutation,
  useGetReportAttendanceForDayQuery,
  useGetVisitsDetailsForDaysQuery,
  useGetMonthAttendanceReportByDepartmentQuery,
  useGetDailyAttendanceDataByManagerQuery,
  useGetReportAttendanceForDayMutMutation,
  useGetCalculateDepartmentTotalQuery,
} = skudApi;
